export const LETTRE_RGPD_URL_DEFAULT = 'https://www.april-moto.com/wp-content/uploads/2021/11/Lettre-RGPD-APRIL-Moto-AM21-11.pdf';
export const RGPD_CONTROLLER_NAME_DEFAULT = 'APRIL Moto';

interface RgpdInfoBlocProps {
  className?: string;
  /** Lien vers la Lettre d'information RGPD (par défaut : lettre APRIL Moto) */
  letterUrl?: string;
  /** Nom du responsable de traitement (par défaut : APRIL Moto ; ex: AMGESTION pour MAE) */
  controllerName?: string;
}

/**
 * Bloc d'information RGPD : mention sur le traitement des données + lien vers la
 * Lettre d'information sur les Traitements des données personnelles.
 * Réutilisé en bas de la page "Vos informations" et dans la fenêtre de rappel.
 * Le lien de la lettre et le responsable de traitement sont configurables par
 * formulaire (ex: AMGESTION pour MAE).
 */
export function RgpdInfoBloc({
  className,
  letterUrl = LETTRE_RGPD_URL_DEFAULT,
  controllerName = RGPD_CONTROLLER_NAME_DEFAULT,
}: RgpdInfoBlocProps) {
  return (
    <p className={`text-xs text-gray-500 ${className ?? ''}`}>
      Les données collectées dans le présent formulaire sont traitées par {controllerName} pour répondre à votre demande.
      Pour en savoir plus sur ces traitements et sur les droits dont vous bénéficiez, consultez la{' '}
      <a
        className="text-primary font-medium hover:text-primary-600 hover:underline"
        href={letterUrl}
        rel="noreferrer noopener"
        target="_blank"
      >
        Lettre d&apos;information sur les Traitements de vos données personnelles
      </a>
    </p>
  );
}
